export const healthWidgetIconConfig = {
    left: {
      width: 90,
      height: 90,
      className: 'healthWidgetPlusLeftIcon',
      imagePath: 'health/plus_left_tilt.svg',
    },
    right: {
      width: 45,
      height: 45,
      className: 'healthWidgetPlusRightIcon',
      imagePath: 'health/plus_right_tilt.svg',
    },
  }
